<template>
  <div class="container flex min-h-screen flex-col">
    <div class="header mb-3 box-shadow-primary">
      <div class="back-button" @click="$emit('backClick')">
        <svg width="15" fill="#fff" viewBox="0 0 492 492" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M198.608 246.104L382.664 62.04c5.068-5.056 7.856-11.816 7.856-19.024 0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12C361.476 2.792 354.712 0 347.504 0s-13.964 2.792-19.028 7.864L109.328 227.008c-5.084 5.08-7.868 11.868-7.848 19.084-.02 7.248 2.76 14.028 7.848 19.112l218.944 218.932c5.064 5.072 11.82 7.864 19.032 7.864 7.208 0 13.964-2.792 19.032-7.864l16.124-16.12c10.492-10.492 10.492-27.572 0-38.06L198.608 246.104z"/></svg>
      </div>
      <div class="center-heading">
        <div class="progress-wrapper">
          <div
            class="progress"
            :class="{ completed: currentStep >= index + 1 }"
            v-for="(steps, index) in stepCount"
            :key="index + 1"
          ></div>
        </div>
      </div>

      <div class="close-button" @click="$emit('closeClick')">
        <svg fill="#fff" width="15" viewBox="0 0 492 492" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M300.188 246L484.14 62.04c5.06-5.064 7.852-11.82 7.86-19.024 0-7.208-2.792-13.972-7.86-19.028L468.02 7.872C462.952 2.796 456.196.016 448.984.016c-7.2 0-13.956 2.78-19.024 7.856L246.008 191.82 62.048 7.872C56.988 2.796 50.228.016 43.02.016c-7.2 0-13.96 2.78-19.02 7.856L7.872 23.988c-10.496 10.496-10.496 27.568 0 38.052L191.828 246 7.872 429.952C2.808 435.024.02 441.78.02 448.984c0 7.204 2.788 13.96 7.852 19.028l16.124 16.116c5.06 5.072 11.824 7.856 19.02 7.856 7.208 0 13.968-2.784 19.028-7.856l183.96-183.952 183.952 183.952c5.068 5.072 11.824 7.856 19.024 7.856h.008c7.204 0 13.96-2.784 19.028-7.856l16.12-16.116c5.06-5.064 7.852-11.824 7.852-19.028 0-7.204-2.792-13.96-7.852-19.028L300.188 246z"/></svg>
      </div>
    </div>
    <div class="flex-1">
      <slot />
    </div>

    <div class="footer text-right justify-end">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: "layout-challenge",
  props: ["stepCount", "currentStep"],

  methods: {
    handleBackClick() {}
  },
  mounted() {
    if (window.innerHeight > 600) {
      document.querySelector(".header").style.position = "sticky";
    }
  }
};
</script>

<style lang="scss" scoped>
.progress {
  height: 4px;
  flex-grow: 1;
  border-radius: 4px;
  margin: 0 5px;
  display: flex;
  background-color: white;

  &.completed {
    background-color: #f79b77;
  }
}

.progress-wrapper {
  // flex-grow: 1;
  display: flex;
  // margin: 0 20px;
}

.center-heading {
  flex-grow: 1;
  display: flex;

  flex-direction: column;
  justify-content: center;
  // align-items: center;
  height: 100%;

  h2 {
    color: white;
    // margin-top: 5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-items: flex-end;
  }
}
.back-button,
.close-button {
  height: 100%;
  display: flex;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
.back-button {
  padding-right: 20px;
}

.close-button {
  padding-left: 20px;
}

.footer {
  position: sticky;
  bottom: 10px;
  display: flex;
  flex-direction: row;
  margin: 0px 20px;
}

.footer-item {
  flex: 1;
  padding: 10px 5px;
  /* padding-bottom: 10px; */
  display: flex;
  font-size: 0.75rem;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: gray;
}

img {
  /* max-width: 80%; */
  width: 40px;
  /* margin: 0 auto; */
  display: block;
}

.router-link-active {
  fill: #5f4d7c;
  font-weight: bold;
  color: #5f4d7c;
}
.router-link-active > svg {
  fill: #5f4d7c;
}

.button-answer {
  background-color: #c4c4c4;
  color: white;
  font-weight: bold;
  border-bottom: 4px solid darken(#999, 10%);

  &.active {
    background-color: #f79b77 !important;
  }
}
</style>
